export const STARRED_SECTION = 'starred';
export const RECENT_SECTION = 'recent';

export type ProjectSectionType = typeof STARRED_SECTION | typeof RECENT_SECTION;
